import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Media,
  Collapse,
  Form,
  Input,
  Label,
  Button,
  FormFeedback,
  Modal,
  TabContent,
  TabPane,
  NavLink,
  NavItem,
  Nav,
} from "reactstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { changePdfErrorInfoList, getMadridPdfErrorInfoList, savePdfErrorInfoList, setAdmDataManagementError } from "../../store/actions";
import PeriodBtn from "../../components/Filter/PeriodBtn";
import { useState } from "react";
import { cloneDeep, filter } from 'lodash';

function MadridPdfErrorInfo({ toggle, activeTab, isOpen, tabId }) {

  const dispatch = useDispatch();

  const { noticeStr, totalPage, pdfErrorInfoList } = useSelector(state => ({
    noticeStr: state.admDataManagement.noticeStrError,
    totalPage: state.admDataManagement.totalPageError,
    pdfErrorInfoList: state.admDataManagement.pdfErrorInfoList,
  }))

  const filterValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      submitType: "view",

      perPage: 20,
      curPage: 1,
      datePeriod: "",
      fromDate: "",
      toDate: "",
      outstandingYn: "A"
    },

    onSubmit: (values) => {

      console.log()

      let submitType = values["submitType"];

      if (submitType === "view") {
        const filterParam = {
          limit: values.perPage,
          curPage: values.curPage,
          fromDate: values.fromDate?.replace(/-/g, "") ?? "",
          toDate: values.toDate?.replace(/-/g, "") ?? "",
          outstandingYn: values.outstandingYn
        };
        dispatch(getMadridPdfErrorInfoList(filterParam));
      } else if (submitType === "save") {
        const _pdfErrorInfoList = [];
        pdfErrorInfoList.forEach(info => {
          if (info.checked) {
            _pdfErrorInfoList.push(info);
            info.checked = false
          }
        });
        if (_pdfErrorInfoList.length > 0) {
          dispatch(savePdfErrorInfoList(_pdfErrorInfoList))
          dispatch(changePdfErrorInfoList(pdfErrorInfoList))
        } else {
          dispatch(setAdmDataManagementError("Please select a record!"));
        }
      }
    }
  })

  const [chkAllFlag, setChkAllFlag] = useState(false);
  const onInfoCheck = (chkIdx, value) => {
    let _pdfErrorInfoList = cloneDeep(pdfErrorInfoList);

    if (chkIdx == "chkAll") {
      setChkAllFlag(value);
      _pdfErrorInfoList = _pdfErrorInfoList.map((info, idx) => {
        info.checked = value;
        return info;
      })
    } else {
      if (chkAllFlag && !value) setChkAllFlag(false);
      _pdfErrorInfoList[chkIdx].checked = value
    }

    dispatch(changePdfErrorInfoList(_pdfErrorInfoList));
  }

  const onPageChange = (curPage, perPage) => {
    filterValidation.setFieldValue("submitType", "view");

    if (curPage) {
      // setCurPageInput(curPage);
      filterValidation.setFieldValue("curPage", curPage);
    } else {
      // setCurPageInput(1);
      filterValidation.setFieldValue("curPage", 1);
    }

    if (perPage) {
      filterValidation.setFieldValue("perPage", perPage);
    }

    filterValidation.handleSubmit(filterValidation.values);
  }

  return (
    <TabPane style={activeTab === tabId ? {display: "block"} : {display: "none"}} tabId={tabId}>
      <Row>
        <Col lg={12}>
          <Card>
            <Link onClick={toggle} className="text-dark" to="#">
              <div className="p-4">
                <Media className="d-flex align-items-center">
                  <div className="flex-shrink-0 me-3">
                    <i className="uil uil-file-copy-alt text-primary h2"></i>
                  </div>
                  <div className="flex-grow-1 overflow-hidden">
                    <h5 className="font-size-16 mb-1">Data Management</h5>
                  </div>
                  <i className="uil uil-filter font-size-24 text-muted"></i>
                </Media>
              </div>
            </Link>
            <Collapse isOpen={isOpen}>
              <div className="p-4 border-top">
                <Row>
                  <label htmlFor="inscribedDate" className="col-md-1 col-form-label" style={{ paddingTop: '0px' }}>
                    Date
                  </label>
                  <div className="col-md-11">
                    <PeriodBtn
                      formik={filterValidation}
                    />
                  </div>
                </Row>
                <Row className='mb-3 mt-3'>
                  <label htmlFor="caseVisibility" className="col-md-3 col-form-label">
                    DRU send date
                  </label>
                  <div className="col-md-2 form-check" style={{ paddingLeft: '2em', display:"flex", alignItems: "center", gap: "5px", justifyContent: "center" }}>
                    <input type="radio" className="form-check-input"
                      id="outstandingY"
                      name="outstandingYn"
                      value="Y"
                      onChange={filterValidation.handleChange}
                      checked={filterValidation.values.outstandingYn ==="Y"}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="outstandingY"
                    >
                      Outstanding
                    </label>
                  </div>
                  <div className="col-md-2 form-check" style={{ paddingLeft: '2em', display:"flex", alignItems: "center", gap: "5px", justifyContent: "center" }}>
                    <input type="radio" className="form-check-input"
                      id="outstandingA"
                      name="outstandingYn"
                      value="A"
                      onChange={filterValidation.handleChange}
                      checked={filterValidation.values.outstandingYn == 'A'}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="outstandingA"
                    >
                      All
                    </label>
                  </div>
                </Row>
                <Row >
                  <Col md={2}>&nbsp;</Col>
                  <Col md={3}>&nbsp;</Col>
                  <Col md={3}>
                    <button
                      type="button"
                      className="btn btn-primary waves-effect waves-light col-md-5"
                      onClick={() => {
                        filterValidation.setFieldValue("curPage", 1);
                        filterValidation.setFieldValue("submitType", "view");
                        filterValidation.handleSubmit(filterValidation.values);
                      }}
                    >
                      Search
                    </button>
                  </Col>
                </Row>
              </div>
            </Collapse>
          </Card>
        </Col>
      </Row>
      {
        noticeStr &&
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <CardTitle className="text-muted mb-0">
                  <p style={{ whiteSpace: "pre" }}>
                    {noticeStr}
                  </p>
                </CardTitle>
              </CardBody>
            </Card>
          </Col>
        </Row>
      }
      {
        Array.isArray(pdfErrorInfoList) && pdfErrorInfoList.length > 0 &&
        <Row>
          <Col lg={12}>
            <Card>
              <CardTitle className="text-muted mb-0">
                <Row className="mb-3" style={{ paddingTop: "25px", paddingLeft: "30px" }}>
                  <span className="col-md-8 button-items">
                    <Button
                      type="button"
                      color="primary"
                      className="waves-effect waves-light col-md-2"
                      onClick={() => {
                        filterValidation.setFieldValue("submitType", "save");
                        filterValidation.handleSubmit(filterValidation.values);
                      }}
                    >
                      Save
                    </Button>
                  </span>
                </Row>
              </CardTitle>
              <CardBody>
                <div className="table-responsive">
                  <Table className="table mb-0">
                    <thead>
                      <tr>
                        <th style={{ verticalAlign: "middle", textAlign: "center" }}>
                          <input
                            type="checkbox"
                            checked={chkAllFlag}
                            onClick={(e) => onInfoCheck("chkAll", e.target.checked)}
                          />
                        </th>
                        <th style={{ textAlign: "center" }}>IR</th>
                        <th style={{ textAlign: "center" }}>Inscription</th>
                        <th style={{ textAlign: "center" }}>CR</th>
                        <th style={{ textAlign: "center" }}>WIPO link</th>
                        <th style={{ textAlign: "center" }}>Reg date time</th>
                        <th style={{ textAlign: "center" }}>Last modified date time</th>
                        <th style={{ textAlign: "center" }}>DRU send date</th>
                        <th style={{ textAlign: "center" }}>Last remaining email</th>
                        <th style={{ textAlign: "center" }}>PDF<br />(Inscription date / pdf file doc id)</th>
                        <th style={{ textAlign: "center" }}>Notes</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        pdfErrorInfoList.map((info, index) => {
                          return (
                            <tr key={info.irNumber+"_"+info.inscriptionDate+"_"+info.crCode}>
                              <td align="center" style={{ verticalAlign: "middle" }}>
                                <input type="checkbox"
                                  checked={info.checked}
                                  onClick={(e) => onInfoCheck(index, e.target.checked)}
                                />
                              </td>
                              <td style={{ verticalAlign: "middle",  textAlign: "center"}}>{info.irNumber || "-"}</td>
                              <td style={{ verticalAlign: "middle", textAlign: "center", paddingInline: "0" }}>{info.inscriptionDate || "-"}</td>
                              <td style={{ verticalAlign: "middle",  textAlign: "center"}}>{info.crCode || "-"}</td>
                              <td style={{ verticalAlign: "middle", textAlign: "center", width: "200px", paddingInline: "0" }}>
                                {
                                  info.wipoLink
                                    ? <a style={{ display: "block", width: "180px" }} href={info.wipoLink} target="_blank">{info.wipoLink || "-"}</a>
                                    : <>{info.wipoLink || "-"}</>
                                }
                              </td>
                              <td style={{ verticalAlign: "middle",  textAlign: "center"}}>{info.regDateTime || "-"}</td>
                              <td style={{ verticalAlign: "middle", textAlign: "center", paddingInline: "0" }}>{info.lastModifiedDateTime && info.lastModifiedDateTime === "0000/00/00" ? "-" : info.lastModifiedDateTime || "-"}</td>
                              <td style={{ verticalAlign: "middle", textAlign: "center"}}>
                                <Input
                                  className="form-control"
                                  type="date"
                                  style={{ width: "130px" }}
                                  placeholder="Enter notes"
                                  onChange={(e) => {
                                    let _pdfErrorInfoList = cloneDeep(pdfErrorInfoList);
                                    _pdfErrorInfoList[index].uploadedDate = e.target.value;
                                    dispatch(changePdfErrorInfoList(_pdfErrorInfoList));
                                  }}
                                  value={info.uploadedDate || ""}
                                />
                              </td>
                              <td style={{ verticalAlign: "middle", textAlign: "center", paddingInline: "0" }}>{info.lastRemainingEmailDate && info.lastRemainingEmailDate === "0000/00/00" ? "-" : info.lastRemainingEmailDate || "-"}</td>
                              <td style={{ verticalAlign: "middle",  textAlign: "center"}}>
                                <Input
                                  className="form-control"
                                  type="text"
                                  style={{minWidth: "115px"}}
                                  placeholder="1234567890"
                                  onChange={(e) => {
                                    let _pdfErrorInfoList = cloneDeep(pdfErrorInfoList);
                                    _pdfErrorInfoList[index].pdf = e.target.value;
                                    dispatch(changePdfErrorInfoList(_pdfErrorInfoList));
                                  }}
                                  value={info.pdf}
                                />
                              </td>
                              <td style={{ verticalAlign: "middle", textAlign: "center", paddingInline: "0" }}>
                                <textarea
                                  className="form-control"
                                  style={{ minWidth: "100px" }}
                                  rows={1}
                                  placeholder="Enter notes"
                                  onChange={(e) => {
                                    let _pdfErrorInfoList = cloneDeep(pdfErrorInfoList);
                                    _pdfErrorInfoList[index].notes = e.target.value;
                                    dispatch(changePdfErrorInfoList(_pdfErrorInfoList));
                                  }}
                                  value={info.notes}
                                />
                              </td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  </Table>
                </div>
                <div className="d-flex justify-content-between" style={{ marginTop: "20px" }}>
                  <span className="d-flex align-items-center gap-2">
                    <label
                      htmlFor="perPage"
                    >
                      Entries per page
                    </label>
                    <div style={{ width: "100px" }}>
                      <select
                        className="form-select"
                        name="perPage"
                        onChange={e => { onPageChange(1, e.target.value); }}
                        value={filterValidation.values.perPage}
                      >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="40">40</option>
                        <option value="50">50</option>
                      </select>
                    </div>
                  </span>
                  <span className="d-flex align-items-center gap-2">
                    <div className="d-flex gap-1">
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(1, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == 1)}
                      >
                        {"<<"}
                      </Button>
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(Number(filterValidation.values.curPage) - 1, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == 1)}
                      >
                        {"<"}
                      </Button>
                    </div>
                    Page{" "}
                    <strong>
                      {filterValidation.values.curPage} of {totalPage}
                    </strong>

                    <Input
                      type="number"
                      min={1}
                      style={{ width: 70 }}
                      max={totalPage}
                      name="curPage"
                      defaultValue={filterValidation.values.curPage}
                      value={filterValidation.values.curPage}
                      onChange={(e) => {
                        const _curPage = Math.min(Math.max(e.target.value, 1), totalPage)
                        // setCurPageInput(_curPage, totalPage)
                        filterValidation.setFieldValue("curPage", _curPage);
                      }}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          const _curPage = Math.min(Math.max(e.target.value, 1), totalPage)
                          onPageChange(_curPage, filterValidation.values.perPage);
                        }
                      }}
                    />
                    <div className="d-flex gap-1">
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(Number(filterValidation.values.curPage) + 1, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == totalPage)}
                      >
                        {">"}
                      </Button>
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(totalPage, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == totalPage)}
                      >
                        {">>"}
                      </Button>
                    </div>
                  </span>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      }
    </TabPane>
  )
}

export default MadridPdfErrorInfo;